import genericParamDefinitionModule from "./genericParamDefinitionModule"

const genericParamDefinitionView = require("text!./genericParamDefinitionView.html")

genericParamDefinitionModule.config(["editionServiceProvider", (editionServiceProvider: any) => {
    editionServiceProvider.registerEdition("genericParamDefinition", genericParamDefinitionView, "genericParamDefinitionController", "group.r2.configuration.advanced")
}])